export const SET_SWITCH_TENANCY = "SET_SWITCH_TENANCY";
export const CLEAN_SWITCH_TENANCY = "CLEAN_SWITCH_TENANCY";

export const SET_MODAL_REF = "SET_MODAL_REF";
export const CLEAN_MODAL_REF = "CLEAN_MODAL_REF";
